import { render, staticRenderFns } from "./UserAttendanceDataTable.vue?vue&type=template&id=1f5be885&"
import script from "./UserAttendanceDataTable.vue?vue&type=script&lang=js&"
export * from "./UserAttendanceDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
